import { findNikkeInCatalog } from '../../nikke-catalog/domain/nikkeCatalog.js';
import { ElementIcon } from '../../nikke-catalog/shared/ElementIcon.jsx';
import { useRaidPracticeRecommendationCatalog } from '../hooks/useRaidPracticeRecommendationCatalog.js';
import { siteImageUrl } from '../../../shared/domain/siteImages.js';

function text(value) {
  return String(value ?? '').trim();
}

function burstRoman(item) {
  const value = String(item?.burst || item?.burstCode || '').trim();
  if (value === '1' || value === 'Step1') return 'I';
  if (value === '2' || value === 'Step2') return 'II';
  if (value === '3' || value === 'Step3') return 'III';
  if (value === 'A' || value === 'AllStep') return 'A';
  return '-';
}

export function RaidPracticeRecommendationDeck({ deck = [] }) {
  const { catalog } = useRaidPracticeRecommendationCatalog();
  const codes = (Array.isArray(deck) ? deck : []).map(text).filter(Boolean).slice(0, 5);

  return (
    <div className="practice-rec-icon-strip" aria-label="추천 덱 5명">
      {Array.from({ length: 5 }, (_, index) => {
        const code = codes[index] || '';
        const item = code ? findNikkeInCatalog(catalog, code) : null;
        return (
          <span className="practice-rec-icon" key={`${code || 'empty'}-${index}`} title={item?.name || code || '빈 슬롯'}>
            {item?.imageUrl ? <img src={siteImageUrl(item.imageUrl)} alt="" loading="lazy" /> : <span className="practice-rec-icon-fallback">{item?.name?.slice(0, 1) || '?'}</span>}
            {item ? <b>{burstRoman(item)}</b> : null}
            {item ? <ElementIcon element={item.element} imageUrl={item.elementImageUrl} className="practice-rec-icon-element" /> : null}
          </span>
        );
      })}
    </div>
  );
}
